export enum FranchiseStatus {
  ACTIVE = "ACTIVE",
  AWAITING_CONFIRMATION = "AWAITING CONFIRMATION"
}

export const FranchiseStatusEnumMapping: Record<FranchiseStatus, string> = {
    [FranchiseStatus.ACTIVE]: "ACTIVE",
    [FranchiseStatus.AWAITING_CONFIRMATION]: "AWAITING CONFIRMATION"
  };

export interface FranchiseStatusInterface {
  id: FranchiseStatus;
  value: string;
}
